import { render, staticRenderFns } from "./EditAddressBook.vue?vue&type=template&id=a99c24e0"
import script from "./EditAddressBook.vue?vue&type=script&lang=js"
export * from "./EditAddressBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports